import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as Styled from './Badge.styled';

const Badge = (props) => {
  const { classes, children, variant, className, dot, color } = props;
  return (
    <Styled.BadgeContainer
      dot={dot ? 1 : undefined}
      className={classNames(classes.root, className)}
      color={color}
      variant={variant}>
      {children}
    </Styled.BadgeContainer>
  );
};

Badge.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
  }),
  dot: PropTypes.bool,
  variant: PropTypes.oneOf([
    'error',
    'inactive',
    'warning',
    'success',
    'default',
  ]),
  color: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

Badge.defaultProps = {
  className: '',
  dot: false,
  classes: {
    root: '',
  },
  variant: 'default',
  children: null,
};

export default Badge;
